module.exports = __webpack_public_path__ + "img/google-cloud-blog-01.674d6698.jpg";